import React from 'react';
import { reminderHelpers } from './reminder-helpers';
import { ReminderName, ReminderScheduleText, ReminderTimePicker, TimeLabel } from './common-reminder-components';
import DropdownMain from "../../../../../../components/dropdown-main/DropdownMain";
import PropTypes from 'prop-types';

const OneTimeReminders = ({ taskReminder, setTaskReminder }) => {

    return (
        <div data-testid='one-time-reminders'>
            <ReminderName taskReminder={taskReminder} setTaskReminder={setTaskReminder} />
            <TimeLabel />
            <div className="one-time-recurrence-container">
                <input
                    id="reminderDays"
                    name="reminderDays"
                    value={taskReminder.days}
                    type="number"
                    defaultValue={2}
                    min={1}
                    required
                    onKeyDown={(e) => {
                        (e.key === "Enter" ||
                            e.key === "." ||
                            e.key === "-") &&
                            e.preventDefault();
                    }}
                    onChange={(e) => {
                        e.target.value =
                            e.target.value == 0 ? 1 : e.target.value;
                        reminderHelpers.handleChange("days",e.target.value,setTaskReminder);
                    }}
                    disabled={!taskReminder.exist}
                />

                <h4>days</h4>

                <div className="reminder-dropdown" data-testid='dropdown-main'>
                    <DropdownMain
                        values={reminderHelpers.reminderValues}
                        dropdownButtonText={"-Select-"}
                        onSelect={(selectedValue) => {
                            reminderHelpers.handleChange("reminder",selectedValue,setTaskReminder);
                        }}
                        currentSelected={taskReminder.reminder}
                        disabled={!taskReminder.exist}
                    />
                </div>

                <h4>at</h4>

                <div className="reminder-date-picker">
                    <ReminderTimePicker taskReminder={taskReminder} setTaskReminder={setTaskReminder} />
                </div>
            </div>            
            <ReminderScheduleText taskReminder={taskReminder}/>
        </div>
    );
};

OneTimeReminders.propTypes = {
    taskReminder: PropTypes.shape({
        days: PropTypes.number,
        exist: PropTypes.bool,
        reminder: PropTypes.string,
    }),
    setTaskReminder: PropTypes.func.isRequired,
};

export default OneTimeReminders;